import { Component } from 'react';
import { Sentry } from '../lib/sentry.js';

/**
 * Filet runtime global : un throw au rendu n'aboutit plus à une page blanche
 * sans issue. On affiche une sortie navigable (recharger / accueil).
 * Le catch-all des routes ne couvre que les URL inconnues, pas les crashs.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Remonte le crash à Sentry (no-op si Sentry non configuré).
    Sentry.captureException(error, {
      contexts: { react: { componentStack: info?.componentStack } },
    });
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error('App crash capturé par ErrorBoundary :', error, info);
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container-mobile flex min-h-screen flex-col items-center justify-center text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white/5 text-3xl">
            ⚠️
          </div>
          <h1 className="text-xl font-bold tracking-tight">Une erreur est survenue</h1>
          <p className="mt-2 max-w-xs text-sm text-white/60">
            L&apos;app a rencontré un problème inattendu. Recharge la page ou reviens à l&apos;accueil.
          </p>
          <div className="mt-6 flex w-full max-w-xs flex-col gap-2">
            <button
              type="button"
              className="btn-primary w-full"
              onClick={() => window.location.reload()}
            >
              Recharger
            </button>
            <a href="/" className="btn-secondary w-full text-center">
              Accueil
            </a>
          </div>
          {import.meta.env.DEV ? (
            <pre className="mt-4 max-h-48 max-w-full overflow-auto rounded-lg bg-black/40 p-3 text-left text-[10px] text-red-300">
              {String(this.state.error?.stack ?? this.state.error)}
            </pre>
          ) : null}
        </div>
      );
    }
    return this.props.children;
  }
}
